import { h, Component } from 'preact';
import Store from 'store/store';
import { joinPaths } from 'utils/utils';
import { loadPage } from 'utils/pageComponents';
import { IntentDetector } from 'utils/intentDetector';

export default class PageLink extends Component {

	constructor(props) {
		super(props);
		this.intentDetector = new IntentDetector({
			getBaseEvent: (name) => this.props[name],
			onIntent: this.onIntent.bind(this),
		});
	}

	componentWillUnmount() {
		this.intentDetector.dispose();
	}

	onIntent() {
		loadPage(this.props.to);
	}

	getLink(page = this.props.to) {
		const [pageName, anchor] = page.split('#');
		const base = typeof window !== 'undefined' ? window.__BASE_URL__ : '/';
		const pagePath = Store.get().appData.pages[pageName]?.path || '';
		return anchor ? joinPaths(base, pagePath) + '#' + anchor : joinPaths(base, pagePath);
	}

	render({ to, children, ...props }) {
		return (
			<a
				href={this.getLink(to)}
				{...props}
				{...this.intentDetector.events}
			>
				{children}
			</a>
		);
	}

}